/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { path } from 'ramda';
import RequestService from '../../service/requestService';
import ExportArchiveWithProgressDisplay from './export-archive-status.component';
import {
  exportParticipantArchive,
  fetchExportArchiveStatus,
  initiatedExportParticipantArchive,
  resetInitiatedExportParticipantArchive
} from '../../actions/actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    user: path(['login', 'user'], state),
    sponsor: path(['sponsor', 'selectedSponsor', 'databasename'], state),
    isExportInitiated: path(['reports', 'initiatedParticipantExport'], state),
    exportStudy: path(['reports', 'exportStudy'], state)
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    downloadArchive: ({ studyProtocolNumber, studyGid, username }) => {
      return RequestService.downloadParticipantArchive(studyProtocolNumber, studyGid, username);
    },
    cancelDownloadArchive: ({ sponsor, studyProtocolNumber, studyGid, username }) => {
      return RequestService.cancelDownloadParticipantArchive(sponsor, studyProtocolNumber, studyGid, username);
    },
    cancelExportArchive: ({ sponsor, studyProtocolNumber, studyGid, username }) => {
      return RequestService.cancelExportParticipantArchive({ sponsor, studyProtocolNumber, studyGid, username });
    },
    getProgress: (studyGid, username) => {
      return RequestService.getBatchProgress(studyGid, username);
    },
    fetchStudies: (userId, sponsor) => {
      return RequestService.getAllActiveStudies(userId, sponsor);
    },
    initiatedExportArchive: (study) => {
      dispatch(initiatedExportParticipantArchive(study));
    },
    resetIntiatedExportArchive: () => {
      dispatch(resetInitiatedExportParticipantArchive());
    },
    initiateExportArchive: (study, username) => {
      dispatch(exportParticipantArchive({ study, username }));
    },
    getBatchArchivingStatus: (studyGid) => {
      dispatch(fetchExportArchiveStatus(studyGid));
    }
  };
};

const CExportArchiveWithProgressDisplay = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportArchiveWithProgressDisplay);
export default CExportArchiveWithProgressDisplay;
